import React from 'react';
import { Box, Button, Select, MenuItem, Typography } from '@mui/material';
import { FirstPage, LastPage, NavigateNext, NavigateBefore } from '@mui/icons-material';

const CustomPagination = ({ 
  count, 
  page, 
  rowsPerPage, 
  onPageChange, 
  onRowsPerPageChange 
}) => {
  const totalPages = Math.ceil(count / rowsPerPage);
  
  const getPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(1, page + 1 - 2);
    const endPage = Math.min(totalPages, page + 1 + 2);
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };

  const handlePageChange = (newPage) => {
    if (typeof newPage === 'number' && !isNaN(newPage)) {
      onPageChange(newPage);
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      p: 2,
      borderTop: '1px solid rgba(224, 224, 224, 1)'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" sx={{ mr: 2 }}>
          Rows per page:
        </Typography>
        <Select
          size="small"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(e)}
          sx={{ minWidth: 80 }}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          size="small"
          onClick={() => handlePageChange(0)}
          disabled={page === 0}
          startIcon={<FirstPage />}
        />
        <Button
          size="small"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 0}
          startIcon={<NavigateBefore />}
        />
        
        {getPageNumbers().map((pageNum) => (
          <Button
            key={pageNum}
            size="small"
            onClick={() => handlePageChange(pageNum - 1)}
            variant={pageNum === page + 1 ? "contained" : "text"}
            sx={{ minWidth: 32 }}
          >
            {pageNum}
          </Button>
        ))}
        
        <Button
          size="small"
          onClick={() => handlePageChange(page + 1)}
          disabled={page >= totalPages - 1}
          endIcon={<NavigateNext />}
        />
        <Button
          size="small"
          onClick={() => handlePageChange(totalPages - 1)}
          disabled={page >= totalPages - 1}
          endIcon={<LastPage />}
        />
      </Box>

      <Typography variant="body2">
        {`${page * rowsPerPage + 1}-${Math.min((page + 1) * rowsPerPage, count)} of ${count}`}
      </Typography>
    </Box>
  );
};

export default CustomPagination; 